module.exports = __webpack_public_path__ + "media/images/exclamation-circle-icon-9e022e47b73957c98d6a2c784a880ed0.svg";